import classes from "./classes.module.scss";
import { memo, useCallback, useState } from "react";
import MediaResponseResource from "common/resources/Project/Config/Media/MediaResponseResource";
import MediaCard from "./MediaCard";
import MediaModal from "./MediaModal";
import ManageCardMenu from "../../../components/ManageCardMenu";

type IProps = {
	media: MediaResponseResource;
	onEditClick: (media: MediaResponseResource) => void;
	onDeleteClick: (media: MediaResponseResource) => void;
};

function MediaContainer(props: IProps) {
	const [mediaOpen, setMediaOpen] = useState<MediaResponseResource | null>(null);

	const onEditClick = useCallback(() => {
		props.onEditClick(props.media);
	}, [props]);

	const onDeleteClick = useCallback(() => {
		props.onDeleteClick(props.media);
	}, [props]);

	return (
		<div className={classes["root"]}>
			<ManageCardMenu onEditClick={onEditClick} onDeleteClick={onDeleteClick} className={classes["card-menu"]} />

			<MediaCard media={props.media} onOpen={setMediaOpen} />
			{mediaOpen && <MediaModal media={mediaOpen} isOpen={!!mediaOpen} onClose={() => setMediaOpen(null)} />}
		</div>
	);
}

export default memo(MediaContainer);
